/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { StatsBillingGetResponse } from './StatsBillingGetResponse';
import {
    StatsBillingGetResponseFromJSON,
    StatsBillingGetResponseFromJSONTyped,
    StatsBillingGetResponseToJSON,
} from './StatsBillingGetResponse';

/**
 * 
 * @export
 * @interface GetStatsBilling200Response
 */
export interface GetStatsBilling200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetStatsBilling200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetStatsBilling200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {StatsBillingGetResponse}
     * @memberof GetStatsBilling200Response
     */
    result: StatsBillingGetResponse;
}

/**
 * Check if a given object implements the GetStatsBilling200Response interface.
 */
export function instanceOfGetStatsBilling200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetStatsBilling200ResponseFromJSON(json: any): GetStatsBilling200Response {
    return GetStatsBilling200ResponseFromJSONTyped(json, false);
}

export function GetStatsBilling200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatsBilling200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': StatsBillingGetResponseFromJSON(json['result']),
    };
}

export function GetStatsBilling200ResponseToJSON(value?: GetStatsBilling200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': StatsBillingGetResponseToJSON(value.result),
    };
}

